import { message } from 'antd';

message.config({
  maxCount: 3,
});

export default message;
